import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { billableBoxDisabled } from './billableAuthorityModel';

/** BQ-069(a) (D-71): is the "לחיוב" box disabled for the caller on this task (the server's own rule). */
export function useBillableBoxDisabled(ticketId: string | null | undefined): boolean {
  const q = useQuery({
    queryKey: ['work-logs', 'billable-authority', ticketId],
    queryFn: () => api.getBillableAuthority(ticketId!),
    enabled: !!ticketId,
    staleTime: 60_000,
  });
  return billableBoxDisabled(q.data?.data);
}
